module.exports = __webpack_public_path__ + "img/orange_037.3deea551.png";